import { Model, attr } from '@elatonsev/js-models';

export default class PointSettingsModel extends Model {
  is_online_payment_required = attr('boolean', {defaultValue: false});
}